module.exports = __webpack_public_path__ + "img/live-state-icon.fb98a89.png";